export type ScrollMetrics = {
  readonly scrollTop: number;
  readonly scrollHeight: number;
  readonly clientHeight: number;
};

export const FOCUS_PIN_THRESHOLD_PX = 64;
export const FOCUS_MESSAGE_PAGE_SIZE = 100n;
export const FOCUS_MESSAGE_PAGE_LIMIT = 6;

export function isPinnedToEnd(
  metrics: ScrollMetrics,
  threshold: number = FOCUS_PIN_THRESHOLD_PX,
): boolean {
  return metrics.scrollHeight - metrics.clientHeight - metrics.scrollTop <= threshold;
}

export function preservedScrollTop(
  previousScrollTop: number,
  previousScrollHeight: number,
  nextScrollHeight: number,
): number {
  return Math.max(0, previousScrollTop + nextScrollHeight - previousScrollHeight);
}

export function initialMessageCursor(headSequence: string): string {
  const head = BigInt(headSequence);
  return head > FOCUS_MESSAGE_PAGE_SIZE ? (head - FOCUS_MESSAGE_PAGE_SIZE).toString(10) : "0";
}

export function previousMessageCursor(currentCursor: string): string | undefined {
  const current = BigInt(currentCursor);
  if (current === 0n) return undefined;
  return current > FOCUS_MESSAGE_PAGE_SIZE ? (current - FOCUS_MESSAGE_PAGE_SIZE).toString(10) : "0";
}

export function boundedPreviousMessageCursor(
  currentCursor: string,
  loadedPageCount: number,
): string | undefined {
  return loadedPageCount >= FOCUS_MESSAGE_PAGE_LIMIT ? undefined : previousMessageCursor(currentCursor);
}
